import { React, useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SubtaskObject from '@atlaskit/object/subtask';

import {
 
  Box,
  Flex,
  Text,
  Input,
  IconButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Select,
} from '@chakra-ui/react';
import {
  FaLock,
  FaEye,
  FaShareAlt,
  FaUserCircle,
  FaEdit,
} from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { MdOutlinePerson } from 'react-icons/md';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FiMoreHorizontal } from 'react-icons/fi';
import { DeleteIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/react';
import UserAvatar from '../../../../components/userAvatar/index';

import {
  AddIcon,
  ChatIcon,
  RepeatIcon,
  BiReply,
  ChevronDownIcon,
} from '@chakra-ui/icons';
import { Spinner } from 'reactstrap';
import SubTaskModal from './SubTaskModal';
import { useParams } from 'react-router-dom';
import { DeleteOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

const Tasksubtasktable = ({
  assigneeList,
  statusList,
  taskdata,
  taskDetails,
  reload,
  projectId,
  opensubtaskmodal,
}) => {

  const [childTasks, setChildTasks] = useState([]);
  const [editableTasks, setEditableTasks] = useState({});
  const [loadingSubtasks, setLoadingSubtasks] = useState(false);
  const [openSubTaskModal, setOpenSubTaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);

  const handleOpenSubtask = (subtask) => {
    setSelectedSubtask(subtask);
    setOpenSubTaskModal(true);
  };

  const handleCloseSubtask = () => {
    setOpenSubTaskModal(false);
    setSelectedSubtask(null);
  };

  const roleId = Number(Cookies.get('task-role-id'));

  useEffect(() => {
    getsubtaskList();
  }, [taskdata, reload]);

  const getsubtaskList = async () => {
    setLoadingSubtasks(true);
    let reqbody = {
      project_id: taskDetails?.project_id ? taskdata?.project_id : projectId,
      issue_id: taskdata?.issue_id,
    };
  

    try {
      const response = await httpInjectorService.getsubtaskList(reqbody);
      setChildTasks(response.data);
      // assuming array of { id, title }
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    } finally {
      setLoadingSubtasks(false);
    }
  };

  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };

  const saveSubtask = async (subtaskId, updatedFields = {}) => {
    const edited = editableTasks[subtaskId] || {};
    const original = childTasks.find((t) => t.subtask_id === subtaskId);

    if (!original) {
      return;
    }

    const reqBody = {
      project_id: taskdata?.project_id ? taskdata.project_id : projectId,
      subtask_id: subtaskId,
      title: edited.title !== undefined ? edited.title : original.subtask_title,
      subtask_status: updatedFields.status
        ? updatedFields.status
        : original.status,
      subtask_priority: updatedFields.priority
        ? updatedFields.priority
        : original.priority,
      subtask_assignee_id: updatedFields.assignee_id
        ? updatedFields.assignee_id
        : original.assignee_id,
         work_item_url:`${window.location.origin}/admin/taskBoard/${taskdata?.project_id ? taskdata.project_id : projectId}/subtaskDetails/${subtaskId}`
    };

    try {
      const response = await httpInjectorService.updateSubtask(reqBody);
      if (response.status === 'success') {
        getsubtaskList();
        // Optionally refresh or give feedback
      }
    } catch (error) {
     throw error
    }
  };

  const deleteChildTask = async (subtaskId) => {
    try {
      let reqbody = {
        project_id: taskdata.project_id,
        subtask_ids: [subtaskId],
      };
      let response = await httpInjectorService.delete_subtask(reqbody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setChildTasks((prev) =>
          prev.filter((task) => task.subtask_id !== subtaskId),
        );
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
     throw error
    }
  };

  const status = taskdata?.subtask_status_count || {};
 
  const done = parseInt(status?.DONE || 0, 10);

  const total = parseInt(status?.task_count || 0, 10);
  
  const donePercent = total > 0 ? (done / total) * 100 : 0;

  return (
    <div>
      {' '}
      {childTasks?.length > 0 && [1, 2, 3].includes(roleId) && (
        <Box mt={6}>
          <Text fontWeight="semibold" mb={2}>
            SubTasks
          </Text>
          {taskdata?.subtask_status_count && (
            <Box mb={1}>
              <Flex align="center" gap={4}>
                {/* Progress Bar */}
                <Flex
                  w="100%"
                  h="10px"
                  borderRadius="8px"
                  overflow="hidden"
                  bg="#E2E8F0"
                >
                  {(() => {
                    const counts = taskdata.subtask_status_count;
                    const total =
                      Number(taskdata?.subtask_status_count?.subtask_count) ||
                      1;

                    // Fixed
                    const todo = Number(counts['TO DO'] || 0);
                    const done = Number(counts['DONE'] || 0);

                    // Dynamic statuses (merged into BLUE)
                    let blue = 0;
                    let blueStatusText = [];

                    Object.keys(counts).forEach((key) => {
                      if (
                        key !== 'TO DO' &&
                        key !== 'DONE' &&
                        key !== 'subtask_count'
                      ) {
                        const c = Number(counts[key] || 0);
                        blue += c;
                        blueStatusText.push(`${key}: ${c}`);
                      }
                    });

                    const todoPercent = (todo / total) * 100;
                    const bluePercent = (blue / total) * 100;
                    const donePercent = (done / total) * 100;

                    return (
                      <>
                        {/* DONE (green) */}
                        <Tooltip
                          label={`DONE: ${done} of ${total}`}
                          hasArrow
                          placement="top"
                        >
                          <Box
                            w={`${donePercent}%`}
                            bg="#38A169"
                            mx="1px"
                            borderRadius="4px"
                          />
                        </Tooltip>

                        {/* BLUE (other statuses) */}
                        <Tooltip
                          label={`IN PROGRESS: ${blue} of ${total}`}
                          hasArrow
                          placement="top"
                        >
                          <Box
                            w={`${bluePercent}%`}
                            bg="#3182CE"
                            mx="1px"
                            borderRadius="4px"
                          />
                        </Tooltip>
                        {/* TO DO (grey) */}
                        <Tooltip
                          label={`TO DO: ${todo} of ${total}`}
                          hasArrow
                          placement="top"
                        >
                          <Box
                            w={`${todoPercent}%`}
                            bg="#A0AEC0"
                            mx="1px"
                            borderRadius="4px"
                          />
                        </Tooltip>
                      </>
                    );
                  })()}
                </Flex>

                {/* Work Done Percentage */}
                <Text fontWeight="600" whiteSpace="nowrap">
                  Done: {Math.round(donePercent)}%
                </Text>
              </Flex>
            </Box>
          )}

          <Box
            borderWidth="1px"
            borderRadius="md"
            overflow="hidden"
            boxShadow="sm"
          >
            <Box maxH="300px" overflowY="auto">
              <Table size="sm" border="1px solid #E2E8F0">
                <Thead bg="gray.100" position="sticky" top={0} zIndex={0}>
                  <Tr>
                    <Th borderRight="1px solid #E2E8F0"></Th>
                    <Th borderRight="1px solid #E2E8F0" w="300px">
                      Work
                    </Th>
                    <Th borderRight="1px solid #E2E8F0">Priority</Th>
                    <Th borderRight="1px solid #E2E8F0">Assignee</Th>
                    <Th>Status</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {childTasks?.map((task) => {
                    const edited = editableTasks[task.subtask_id] || {};

                    const assigneeIdToUse =
                      edited.assignee_id !== undefined
                        ? edited.assignee_id
                        : task.assignee_id;

                    const assigneeObj = assigneeList?.find(
                      (a) => a.user_id === assigneeIdToUse,
                    );

                    const subtaskTitle =
                      edited.title !== undefined
                        ? edited.title
                        : task?.subtask_title;

                    const selectedStatus =
                      edited.status || task.status || 'TO DO';

                    const handleSave = () => saveSubtask(task.subtask_id);

                    return (
                      <Tr key={task.subtask_id}>
                        <Td w="150px" borderRight="1px solid #E2E8F0">
                          <Box
                            as="button"
                            display="flex"
                            alignItems="center"
                            gap="0px"
                            bg="transparent"
                            border="none"
                            cursor="pointer"
                            color="#3182ce"
                            fontWeight="500"
                            padding={0}
                            _hover={{
                              textDecoration: 'underline',
                              color: '#0056b3',
                            }}
                            onClick={() => opensubtaskmodal(task)}
                          >
                            <SubtaskObject
                              size={20}
                              stroke="#0052CC"
                              fill="white"
                              strokeWidth={2}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                lineHeight: 1,
                              }}
                            />
                            {task.subtask_key}
                          </Box>
                        </Td>

                        {/* Editable title */}
                        <Td borderRight="1px solid #E2E8F0" w="300px">
                          <Tooltip
                            label={subtaskTitle}
                            hasArrow
                            placement="top"
                            openDelay={300}
                          >
                            <Input
                              size="sm"
                              value={subtaskTitle}
                              onChange={(e) =>
                                handleEditChange(
                                  task.subtask_id,
                                  'title',
                                  e.target.value,
                                )
                              }
                              onKeyDown={(e) =>
                                e.key === 'Enter' && handleSave()
                              }
                              onBlur={handleSave}
                            />
                          </Tooltip>
                        </Td>

                        {/* Priority */}
                        <Td borderRight="1px solid #E2E8F0">
                          <Menu>
                            <MenuButton
                              as={Button}
                              size="xs"
                              variant="outline"
                              colorScheme="gray"
                              rightIcon={<ChevronDownIcon />}
                            >
                              {edited.priority || task.priority || 'Medium'}
                            </MenuButton>
                            <MenuList>
                              {['Low', 'Medium', 'High'].map((priority) => (
                                <MenuItem
                                  key={priority}
                                  onClick={() => {
                                    handleEditChange(
                                      task.subtask_id,
                                      'priority',
                                      priority,
                                    );
                                    saveSubtask(task.subtask_id, { priority });
                                  }}
                                >
                                  {priority}
                                </MenuItem>
                              ))}
                            </MenuList>
                          </Menu>
                        </Td>

                        {/* Assignee */}
                        <Td borderRight="1px solid #E2E8F0">
                          <Menu isLazy>
                            <Tooltip
                              label={
                                assigneeObj
                                  ? assigneeObj.username
                                  : 'Unassigned'
                              }
                              hasArrow
                              placement="top"
                              openDelay={300}
                            >
                              <MenuButton
                                as={Button}
                                variant="ghost"
                                size="sm"
                                rightIcon={<ChevronDownIcon />}
                              >
                                <Box>
                                  <UserAvatar
                                    username={
                                      assigneeObj
                                        ? assigneeObj.username
                                        : 'Unassigned'
                                    }
                                    size={24}
                                  />
                                </Box>
                              </MenuButton>
                            </Tooltip>

                            <MenuList
                              maxH="200px"
                              overflowY="auto"
                              zIndex={1500}
                            >
                              {assigneeList?.map((assignee) => (
                                <MenuItem
                                  key={assignee.user_id}
                                  onClick={() => {
                                    handleEditChange(
                                      task.subtask_id,
                                      'assignee_id',
                                      assignee.user_id,
                                    );
                                    saveSubtask(task.subtask_id, {
                                      assignee_id: assignee.user_id,
                                    });
                                  }}
                                >
                                  <Tooltip
                                    label={assignee.username}
                                    hasArrow
                                    placement="right"
                                    openDelay={300}
                                  >
                                    <Flex align="center" gap="2">
                                      <UserAvatar
                                        username={assignee.username}
                                        size={24}
                                      />
                                      <Text fontSize="sm">
                                        {assignee.username}
                                      </Text>
                                    </Flex>
                                  </Tooltip>
                                </MenuItem>
                              ))}
                            </MenuList>
                          </Menu>
                        </Td>

                        {/* Status */}
                        <Td borderRight="1px solid #E2E8F0">
                          <Menu>
                            <MenuButton
                              as={Button}
                              size="xs"
                              variant="outline"
                              colorScheme="gray"
                              rightIcon={<ChevronDownIcon />}
                            >
                              {selectedStatus}
                            </MenuButton>
                            <MenuList>
                              {statusList?.map((status) => (
                                <MenuItem
                                  key={status.status_name}
                                  onClick={() => {
                                    handleEditChange(
                                      task.subtask_id,
                                      'status',
                                      status.status_name,
                                    );
                                    saveSubtask(task.subtask_id, {
                                      status: status.status_name,
                                    });
                                  }}
                                >
                                  {status.status_name}
                                </MenuItem>
                              ))}
                            </MenuList>
                          </Menu>
                        </Td>

                        <Td textAlign="center">
                          <IconButton
                            aria-label="Delete subtask"
                            icon={<DeleteIcon />}
                            size="sm"
                            variant="ghost"
                            colorScheme="red"
                            onClick={() =>
                              deleteChildTask(task.subtask_id, task.subtask_key)
                            }
                            _hover={{
                              bg: 'red.50',
                            }}
                          />
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Box>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default Tasksubtasktable;
